<template>
  <div>
    <b-notification :closable="false">
      <strong>{{
        $t(
          'compCarbonFormsRactivitiesComponentsLivestockHelpCalculatingMethod.title-1'
        )
      }}</strong>
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsLivestockHelpCalculatingMethod.title-1-1'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsLivestockHelpCalculatingMethod.info-1-1'
          )
        "
      />
      <br />
      <br />
      <strong
        ><em>{{
          $t(
            'compCarbonFormsRactivitiesComponentsLivestockHelpCalculatingMethod.title-1-2'
          )
        }}</em></strong
      >
      <br />
      <span
        v-html="
          $t(
            'compCarbonFormsRactivitiesComponentsLivestockHelpCalculatingMethod.info-1-2'
          )
        "
      />
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
